<script setup>
import { computed } from 'vue'
import { Badge } from '@drama/ui'

import AuditCard from './AuditCard.vue'
import AuditInspector from './AuditInspector.vue'
import AuditJobs from './AuditJobs.vue'
import AuditRequests from './AuditRequests.vue'
import { useAuditText } from './audit-text.js'
import { callOwners, callTotals } from './run-observer.js'

const props = defineProps({
  snapshot: { type: Object, required: true },
  branch: { type: Object, required: true },
  // 详情响应的全部平台调用，跨分支，按创建时间升序。
  calls: { type: Array, required: true },
  // 正在重试的任务 id；整批重试时为 all，空串表示没有。
  retrying: { type: String, default: '' },
})
const emit = defineEmits(['retry'])

const { tr, costLabel } = useAuditText()
const totals = computed(() => callTotals(props.calls))
const owners = computed(() => callOwners(props.snapshot))
</script>

<template>
  <div class="au-tab">
    <div class="au-chips">
      <Badge size="sm">{{ tr('calls.count', { count: totals.count }) }}</Badge>
      <Badge size="sm">{{ tr('calls.totalCost', { cost: costLabel({ cost_micros: totals.cost_micros, charged_points: 0 }) }) }}</Badge>
      <Badge size="sm" :variant="totals.failed ? 'danger' : 'neutral'">{{ tr('calls.failedCount', { count: totals.failed }) }}</Badge>
    </div>
    <AuditCard :title="tr('calls.title')">
      <AuditInspector :calls="calls" :owners="owners" />
    </AuditCard>
    <AuditCard :title="tr('jobs.title')">
      <AuditJobs :branch="branch" :retrying="retrying" @retry="emit('retry', $event)" />
    </AuditCard>
    <AuditCard :title="tr('requests.title')">
      <AuditRequests :snapshot="snapshot" :owners="owners" />
    </AuditCard>
  </div>
</template>
